import script from "./limit-time-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./limit-time-select.vue?vue&type=script&lang=ts&setup=true"

import "./limit-time-select.vue?vue&type=style&index=0&id=cb8d9c96&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb8d9c96"]])

export default __exports__